/* hanzo.lt: Kaching Bundles hides the theme's price sale badge. Savings badges
   ("Sutaupote …", "Sutaupykite …") are kept visible by CSS (data-hz-keep, snippets/price.liquid);
   this script keeps the amount in sync with the bundle the visitor selects
   (bundle full price − bundle price). Other badges (e.g. "Perkant atskirai")
   are left alone. Mirrors hanzo-ee-bundle-badge.js. */
(function () {
  'use strict';
  if (!location.hostname.includes('hanzo.lt')) return;

  function parseMoney(text) {
    if (!text) return NaN;
    var s = text.replace(/[^\d,]/g, '').replace(',', '.');
    return parseFloat(s);
  }

  // rounded to the nearest euro (same as the product-card badges)
  function formatSaving(amount) {
    return Math.round(amount) + ' €';
  }

  // keep the wording set in the product metafield ("Sutaupote" / "Sutaupykite")
  function prefixOf(badge) {
    if (!badge.hasAttribute('data-hz-prefix')) {
      var m = badge.textContent.trim().match(/^(\D*?)\s*\d/);
      badge.setAttribute('data-hz-prefix', (m && m[1].trim()) || 'Sutaupote');
    }
    return badge.getAttribute('data-hz-prefix');
  }

  // Badges marked data-hz-keep in snippets/price.liquid are kept visible by CSS
  // (Kaching's inline display:none can't override it), so there is no flicker.
  function findBadge() {
    return (
      document.querySelector('.product .price__badge-sale[data-hz-keep]') ||
      document.querySelector('.price__badge-sale[data-hz-keep]')
    );
  }

  function show(badge) {
    // drop our own hide (inline !important); the CSS rule keeps it visible
    if (badge.style.getPropertyPriority('display') === 'important') {
      badge.style.removeProperty('display');
    }
  }

  function hide(badge) {
    badge.style.setProperty('display', 'none', 'important');
  }

  function update() {
    var badge = findBadge();
    if (!badge) return;
    var bars = document.querySelectorAll('.kaching-bundles__bar--selected');
    if (!bars.length) return;
    for (var i = 0; i < bars.length; i++) {
      var priceEl = bars[i].querySelector('.kaching-bundles__bar-price');
      var price = parseMoney(priceEl && priceEl.textContent);
      if (!isFinite(price)) continue; // empty duplicate block
      var fullEl = bars[i].querySelector('.kaching-bundles__bar-full-price');
      var full = parseMoney(fullEl && fullEl.textContent);
      if (isFinite(full) && full > price) {
        var label = prefixOf(badge) + ' ' + formatSaving(full - price);
        if (badge.textContent.trim() !== label) badge.textContent = label;
        show(badge);
      } else {
        hide(badge);
      }
      return;
    }
  }

  function start() {
    if (!findBadge()) return;
    if (!document.querySelector('.kaching-bundles')) {
      // widget may mount late; check again for a while
      var tries = 0;
      var probe = setInterval(function () {
        tries++;
        if (document.querySelector('.kaching-bundles')) {
          clearInterval(probe);
          run();
        } else if (tries > 40) {
          clearInterval(probe);
        }
      }, 500);
      return;
    }
    run();
  }

  function run() {
    update();
    setInterval(update, 700);
    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest && e.target.closest('.kaching-bundles__bar')) {
          setTimeout(update, 150);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
